import {
  ChangeDetectionStrategy,
  Component,
  inject,
} from '@angular/core';

import { SnackbarService } from './snackbar.service';

/**
 * Container global de snackbars. Renderiza no `app.component.ts` raiz.
 * Mensagens empilham vertical (mais recente em cima), max-w fixa.
 *
 * Cores por tipo: sucesso=verde, erro=vermelho, info=azul.
 */
@Component({
  selector: 'app-snackbar-host',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="fixed top-4 left-1/2 -translate-x-1/2 z-50 flex flex-col gap-2 pointer-events-none w-full max-w-sm px-4"
      aria-live="polite"
    >
      @for (m of svc.mensagens(); track m.id) {
        <div
          role="status"
          class="pointer-events-auto rounded-xl shadow-xl p-3 text-center font-medium animate-slide-down"
          [class.bg-emerald-500]="m.tipo === 'sucesso'"
          [class.bg-red-500]="m.tipo === 'erro'"
          [class.bg-blue-500]="m.tipo === 'info'"
          [class.text-white]="true"
        >
          <button
            type="button"
            (click)="svc.dispensar(m.id)"
            class="w-full text-left"
            [attr.aria-label]="'Dispensar mensagem'"
          >
            {{ m.texto }}
          </button>
        </div>
      }
    </div>
  `,
  styles: `
    @keyframes slide-down {
      from { opacity: 0; transform: translateY(-12px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .animate-slide-down { animation: slide-down 200ms ease-out; }
  `,
})
export class SnackbarHostComponent {
  protected readonly svc = inject(SnackbarService);
}
